module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray-4325b760b2677c62f17f7729a6579349.png";